import * as actionTypes from "../action-types";

//! Yatra
export const getYatra = payload => ({ type: actionTypes.GET_YATRA, payload });
export const getYatraDetails = (payload) => ({ type: actionTypes.GET_YATRA_DETAILS, payload });
export const bookYatra = payload => ({ type: actionTypes.BOOK_YATRA, payload });

//! Product
export const getProductCategory = payload => ({ type: actionTypes.GET_PRODUCT_CATEGORY, payload });
export const getProduct = payload => ({ type: actionTypes.GET_PRODUCT, payload });

export const addProductToCart = payload => ({ type: actionTypes.ADD_PRODUCT_TO_CART, payload });
export const updateProductCart = payload => ({ type: actionTypes.UPDATE_PRODUCT_CART, payload });
export const getProductCart = payload => ({ type: actionTypes.GET_PRODUCT_CART, payload });
export const setProductCart = payload => ({ type: actionTypes.SET_PRODUCT_CART, payload });
export const bookProductCart = payload => ({ type: actionTypes.BOOK_PRODUCT_CART, payload });

export const bookPitrPaksha = payload => ({ type: actionTypes.BOOK_PITR_PAKSHA, payload });

//! Puja
export const getPuja = payload => ({ type: actionTypes.GET_PUJA, payload });
export const bookPuja = payload => ({ type: actionTypes.BOOK_PUJA, payload });